/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
} from './Document';
import type { ScreenerAdditionalDocument } from './ScreenerAdditionalDocument';
import {
    ScreenerAdditionalDocumentFromJSON,
    ScreenerAdditionalDocumentFromJSONTyped,
    ScreenerAdditionalDocumentToJSON,
} from './ScreenerAdditionalDocument';
import type { ScreenerGeneratedDocument } from './ScreenerGeneratedDocument';
import {
    ScreenerGeneratedDocumentFromJSON,
    ScreenerGeneratedDocumentFromJSONTyped,
    ScreenerGeneratedDocumentToJSON,
} from './ScreenerGeneratedDocument';

/**
 * 
 * @export
 * @interface ExternalEhrDocuments
 */
export interface ExternalEhrDocuments {
    /**
     * 
     * @type {Array<ScreenerGeneratedDocument>}
     * @memberof ExternalEhrDocuments
     */
    generated_documents?: Array<ScreenerGeneratedDocument>;
    /**
     * 
     * @type {Array<Document>}
     * @memberof ExternalEhrDocuments
     */
    screener_documents?: Array<Document>;
    /**
     * 
     * @type {Array<ScreenerAdditionalDocument>}
     * @memberof ExternalEhrDocuments
     */
    additional_documents?: Array<ScreenerAdditionalDocument>;
}

/**
 * Check if a given object implements the ExternalEhrDocuments interface.
 */
export function instanceOfExternalEhrDocuments(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExternalEhrDocumentsFromJSON(json: any): ExternalEhrDocuments {
    return ExternalEhrDocumentsFromJSONTyped(json, false);
}

export function ExternalEhrDocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalEhrDocuments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'generated_documents': !exists(json, 'generated_documents') ? undefined : ((json['generated_documents'] as Array<any>).map(ScreenerGeneratedDocumentFromJSON)),
        'screener_documents': !exists(json, 'screener_documents') ? undefined : ((json['screener_documents'] as Array<any>).map(DocumentFromJSON)),
        'additional_documents': !exists(json, 'additional_documents') ? undefined : ((json['additional_documents'] as Array<any>).map(ScreenerAdditionalDocumentFromJSON)),
    };
}

export function ExternalEhrDocumentsToJSON(value?: ExternalEhrDocuments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'generated_documents': value.generated_documents === undefined ? undefined : ((value.generated_documents as Array<any>).map(ScreenerGeneratedDocumentToJSON)),
        'screener_documents': value.screener_documents === undefined ? undefined : ((value.screener_documents as Array<any>).map(DocumentToJSON)),
        'additional_documents': value.additional_documents === undefined ? undefined : ((value.additional_documents as Array<any>).map(ScreenerAdditionalDocumentToJSON)),
    };
}

